import gql from 'graphql-tag';

export const configFragment = gql`
  fragment configFragment on Config {
    dokkioClass
    effectiveSliceWideFeatures
  }
`;
export default configFragment;
